import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

const HeaderWrapper = styled.header`
  background-color: ${getColor('primaryBlue')};

  height: 75px;
  width: 100%;

  position: fixed;
  top: 0;
  z-index: 50;

  @media (min-width: ${getBreakpoint('lg')}) {
    height: 100px;
  }
`;

export default HeaderWrapper;
